import React from 'react';

/**
 * Allow the user to install an Integration Flow Service, deployed on the Production cloud, Test cloud, or anywhere else.
 * This screen guides them to where to find the credentials they need, then auto-fills the baseUrl when possible.
 * @param {Object} newServiceData = {} - Object containing all the data about the new service being created
 * @param {Function} setNewServiceDetails = {} - Function on ServiceController that allows us to update the newServiceData
 */
const NewIntegrationService = ({ newServiceData, setNewServiceDetails }) => {

    const PUBLIC_ATOM_CLOUD_BASE_URL = 'https://connect.boomi.com';
    const TEST_ATOM_CLOUD_BASE_URL = 'https://test.connect.boomi.com';

    const ATOM_TYPES = [
        {
            name: 'Public Atom Cloud',
            baseUrl: PUBLIC_ATOM_CLOUD_BASE_URL,
        },
        {
            name: 'Test Atom Cloud',
            baseUrl: TEST_ATOM_CLOUD_BASE_URL,
        },
        {
            name: 'Other',
        },
    ];

    const selectedAtomType = ATOM_TYPES.find(type => type.name === newServiceData.atomType);

    const inputFields = selectedAtomType &&
        (
            selectedAtomType.baseUrl === PUBLIC_ATOM_CLOUD_BASE_URL ||
            selectedAtomType.baseUrl === TEST_ATOM_CLOUD_BASE_URL
        ) ?
        <>
            <label>Base Url: </label>
            <input
                key="baseUrl"
                className="form-control"
                value={selectedAtomType.baseUrl}
                disabled
            />
            <label>
                Path To Service:
                <span className="input-required"> *</span>
            </label>
            <input
                className="form-control"
                onChange={({ target }) => setNewServiceDetails(target.value, 'pathToService')}
                value={newServiceData.pathToService}
                required
            />
            <span className="help-block">Found on the Flow Service component in Dell Boomi Integration e.g. /fs/SampleService</span>
            <label>
                Username:
                <span className="input-required"> *</span>
            </label>
            <input
                className="form-control"
                onChange={({ target }) => setNewServiceDetails(target.value, 'basicUsername')}
                value={newServiceData.basicUsername}
                required
            />
            <label>
                Token:
                <span className="input-required"> *</span>
            </label>
            <input
                className="form-control"
                onChange={({ target }) => setNewServiceDetails(target.value, 'basicPassword')}
                value={newServiceData.basicPassword}
                type="password"
                required
            />
        </> : selectedAtomType && (selectedAtomType.name === 'Other') ?
            <>
                <label>
                    Url:
                    <span className="input-required"> *</span>
                </label>
                <input
                    key="url"
                    className="form-control"
                    onChange={({ target }) => setNewServiceDetails(target.value, 'url')}
                    value={newServiceData.url}
                    required
                />
                <label>Username: </label>
                <input
                    className="form-control"
                    onChange={({ target }) => setNewServiceDetails(target.value, 'basicUsername')}
                    value={newServiceData.basicUsername}
                />
                <label>Password: </label>
                <input
                    className="form-control"
                    onChange={({ target }) => setNewServiceDetails(target.value, 'basicPassword')}
                    value={newServiceData.basicPassword}
                    type="password"
                />
            </> : null;

    return (
        <>
            <h1>New Dell Boomi Integration Service</h1>
            <h4>Install a Flow Service from Dell Boomi Integration</h4>
            <label>
                Name: 
                <span className="input-required"> *</span>
            </label>
            <input
                className="form-control"
                onChange={({ target }) => setNewServiceDetails(target.value, 'name')}
                value={newServiceData.name}
                required
            />
            <label>
                Atom Type
                <span className="input-required"> *</span>
            </label>
            <select
                className="form-control"
                value={newServiceData.atomType}
                onChange={({ target }) => {
                    setNewServiceDetails(target.value, 'atomType');
                    setNewServiceDetails(ATOM_TYPES.find(type => type.name === newServiceData.atomType).baseUrl, 'baseUrl');
                }}
                required
            >
                <option 
                    key=""
                    value=""
                >
                    Please select an Atom type 
                </option>
                {
                    ATOM_TYPES.map(region => (
                        <option 
                            key={region.name} 
                            value={region.name}
                        >
                            {region.name}
                        </option>
                    ))
                }
            </select>
            {inputFields}
        </>
    );
};

export default NewIntegrationService;
